import { plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'

import BaseButtonBuilder, { BaseButtonViewData } from '../index'
import { BaseButton, ButtonTypes } from '../types'
import buttonView from './TextButtonView.vue'
import setupView from './TextSetupView.vue'

export default class TextButtonBuilder extends BaseButtonBuilder {
  type = ButtonTypes.Text

  titleKey: string = ButtonTypes.Text

  setupView = setupView
  buttonView = buttonView

  icon = '📜'

  data = {
    text: ''
  }

  getData(button?: TextButton): BaseButtonViewData {
    return button ? { text: button.text } : { text: '' }
  }

  create(): TextButton {
    return plainToInstance(TextButton, {
      text: this.data.text,
      type: ButtonTypes.Text,
      guid: Guid.create().toString()
    })
  }
}

export class TextButton implements BaseButton {
  text!: string
  type!: ButtonTypes.Text
  guid!: string
}
